import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import EmptyListUI from '../../../widgets/output/EmptyListUI'

const PendingMessageApprovalWhatsAppListUI = ({ messages, selectedMessageId, onUpdateMessageClick,
  sendSubmitted, sendSuccessMsg, sendErrorList, onSendClick,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick, context,
  internalSendSubmitted, internalSendSuccessMsg, internalSendErrorList, onSendNoticeToInternalClick,
  onDocsUploadClick, uploadSubmitted, uploadSuccessMsg, uploadErrorList,
  docsUploadMode, onDocsUploadCancel, onDocsUpload, deleteFileMode, selectedFile, onFileDeleteClick, onDocDownloadClick,
  onAddEmailClick, onUpdateEmailClick
}) => {
  const [phoneNumbersMap, setPhoneNumbersMap] = useState({});

  const handleDeletePhone = (messageApprovalId, phoneToDelete) => {
    try {
      const phoneNumbersStr = localStorage.getItem('phoneNumbers');
      if (phoneNumbersStr) {
        const numbersMap = JSON.parse(phoneNumbersStr);
        if (numbersMap[messageApprovalId]) {
          numbersMap[messageApprovalId] = numbersMap[messageApprovalId].filter(
            phone => phone !== phoneToDelete
          );

          localStorage.setItem('phoneNumbers', JSON.stringify(numbersMap));
          setPhoneNumbersMap(numbersMap);
        }
      }
    } catch (error) {
      console.error("Error deleting phone number:", error);
    }
  };

  useEffect(() => {
    const phoneNumbersStr = localStorage.getItem('phoneNumbers');
    if (phoneNumbersStr) {
      try {
        const numbersMap = JSON.parse(phoneNumbersStr);
        setPhoneNumbersMap(numbersMap);
      } catch (error) {
        console.error("Error parsing phone numbers from localStorage:", error);
        setPhoneNumbersMap({});
      }
    }
  }, [messages]);

  return (
    <>
      {
        messages.length > 0 ? (
          messages.map((message, i) => {
            const messagePhones = phoneNumbersMap[message.messageApprovalId] || [];

            return (
              <div key={i}>
                <CardUI>
                  <div className='g_flex_h g_flex_top g_flex_left'>
                    <LabelAndValueUI label='Internal Phone Recipients'>
                      {messagePhones && messagePhones.length > 0 && (
                        <div className="g_flex_v">
                          {messagePhones.map((phone, j) => (
                            <span key={`phone-${j}`} className="g_flex_h g_m_bottom_25">
                              {phone}
                              <span
                                className="icon icon-pencil g_m_left_50"
                                onClick={onUpdateEmailClick}
                                data-message-approval-id={message.messageApprovalId}
                                data-selected-email={phone}
                              />
                              <span
                                className="icon icon-trash-o g_m_left_25"
                                onClick={() => handleDeletePhone(message.messageApprovalId, phone)}
                                title="Delete phone number"
                              />
                            </span>
                          ))}
                        </div>
                      )}


                      {messagePhones && messagePhones.length > 0 && message.emailToList && message.emailToList.length > 0 && (
                        <hr className="g_m_top_25 g_m_bottom_25" />
                      )}


                      {/* {message.emailToList && message.emailToList.length > 0 && (
                        <div className="g_flex_v">
                          {messagePhones && messagePhones.length > 0 && (
                            <div className="g_m_bottom_25"><b>Email Recipients:</b></div>
                          )}
                          {message.emailToList.map((email, j) => (
                            <span key={`email-${j}`} className="g_flex_h g_m_bottom_25">
                              {email}
                              <span
                                className="icon icon-pencil g_m_left_50"
                                onClick={onUpdateEmailClick}
                                data-message-approval-id={message.messageApprovalId}
                                data-selected-email={email}
                              />
                            </span>
                          ))}
                        </div>
                      )} */}


                      {(!messagePhones || messagePhones.length === 0) &&
                        (!message.emailToList || message.emailToList.length === 0) && (
                          <div>No recipients available</div>
                        )}
                    </LabelAndValueUI>
                    <span className='g_m_right_100' />
                    <span className='g_m_right_100' />
                    <LabelAndValueUI label='File Attachments'>
                      {
                        message.fileUploadList.map((file, j) =>
                          <span key={j} className='g_flex_h g_flex_left'>
                            <Link className='g_m_right_50' onClick={onDocDownloadClick} to='#' message-approval-id={message.messageApprovalId} data-file-name={file}>
                              {file}
                            </Link>
                            <span className='icon icon-trash-o g_m_left_50' onClick={onFileDeleteClick}
                              data-message-id={message.messageApprovalId} data-file-name={file} />
                            <SpinnerUI show={selectedFile === file && deleteFileMode} />
                          </span>
                        )}
                    </LabelAndValueUI>
                  </div>
                  {
                    message.updatedByUserName && (
                      <span className='g_flex_v g_text_right g_m_left_auto'>
                        <LabelAndValueUI label='Updated By'>
                          <span>{message.updatedByUserName}</span>
                        </LabelAndValueUI>
                      </span>
                    )
                  }
                </CardUI>
                <LRTableBodyUI>
                  <LRTableRowUI className='g_flex_top'
                    left={<RowLeftUI message={message} />}
                    right={<RowRightUI message={message} selectedMessageId={selectedMessageId} onUpdateMessageClick={onUpdateMessageClick}
                      sendSubmitted={sendSubmitted} sendSuccessMsg={sendSuccessMsg} sendErrorList={sendErrorList} onSendClick={onSendClick}
                      deleteSubmitted={deleteSubmitted} deleteSuccessMsg={deleteSuccessMsg} deleteErrorList={deleteErrorList}
                      onDeleteClick={onDeleteClick} context={context}
                      onSendNoticeToInternalClick={onSendNoticeToInternalClick}
                      internalSendSubmitted={internalSendSubmitted}
                      internalSendSuccessMsg={internalSendSuccessMsg}
                      internalSendErrorList={internalSendErrorList}
                      onDocsUploadClick={onDocsUploadClick}
                      onAddEmailClick={onAddEmailClick}
                      uploadSubmitted={uploadSubmitted}
                      uploadSuccessMsg={uploadSuccessMsg}
                      uploadErrorList={uploadErrorList}
                    />}
                  />
                </LRTableBodyUI>
              </div>
            );
          })
        ) : (
          <EmptyListUI
            context={context}
            createDisabledMessageLabel='No Message Approvals'
          />
        )
      }
      {
        docsUploadMode && (
          <FileUploadModalSF
            context={context}
            titleLabel='Upload Document'
            uploadMode={docsUploadMode}
            onCancelClick={onDocsUploadCancel}
            signedUrlApi={`/api/su/messages/approvals/${selectedMessageId}/fileUploadSignedUrl`}
            onUpload={onDocsUpload}
          />
        )
      }
    </>
  )
}

const RowLeftUI = ({ message }) => {
  const htmlMessage = (message && message.message) ? message.message.replace(/\n/g, '<br/>') : '';
  return (
    <div
      style={{ whiteSpace: 'pre-line' }}
      dangerouslySetInnerHTML={{ __html: htmlMessage }}
    />
  );
};

const RowRightUI = ({ message, selectedMessageId, updateSubmitted, updateSuccessMsg,
  updateErrorList, onUpdateMessageClick, deleteSubmitted, deleteSuccessMsg, deleteErrorList,
  onDeleteClick, sendSubmitted, sendSuccessMsg, sendErrorList, onSendClick, context,
  onDocsUploadClick, uploadSubmitted, uploadSuccessMsg, uploadErrorList,
  onSendNoticeToInternalClick, internalSendSubmitted, internalSendSuccessMsg, internalSendErrorList,
  onAddEmailClick
}) => (
  <div className='g_text_right'>
    <div className='g_flex_v'>
      {/* Edit (pencil) icon */}
      <span
        className='icon icon-pencil'
        onClick={onUpdateMessageClick}
        message-approval-id={message.messageApprovalId}
      />
      <Link to='#' className='g_m_left_50' message-approval-id={message.messageApprovalId}
        onClick={onAddEmailClick}>
        Add Phone Number
      </Link>
    </div>
    {/* Notice To Internal Team Button */}
    {/* {context && context.permissions && context.permissions.includes('su_manage') && ( */}
    <ButtonTinyWithSpinnerUI
      label='Send Notice To Client'
      rowId={message.messageApprovalId}
      onClick={onSendNoticeToInternalClick}
      alignLeft={false}
      busy={selectedMessageId === message.messageApprovalId && internalSendSubmitted}
      successMsg={selectedMessageId === message.messageApprovalId && internalSendSuccessMsg}
      errorList={selectedMessageId === message.messageApprovalId && internalSendErrorList}
    />
    {/* )} */}

    {/* Send Button */}
    {/* {context.permissions.includes('su_manage') && (
      <ButtonTinyWithSpinnerUI
        label='Send Notice To Client'
        rowId={message.messageApprovalId}
        onClick={onSendClick}
        alignLeft={false}
        busy={selectedMessageId === message.messageApprovalId && sendSubmitted}
        successMsg={selectedMessageId === message.messageApprovalId && sendSuccessMsg}
        errorList={selectedMessageId === message.messageApprovalId && sendErrorList}
      />
    )} */}
    {/* Delete Button */}
    {
      <ButtonTinyWithSpinnerUI
        label='Delete'
        rowId={message.messageApprovalId}
        onClick={onDeleteClick}
        alignLeft={false}
        busy={selectedMessageId === message.messageApprovalId && deleteSubmitted}
        successMsg={selectedMessageId === message.messageApprovalId && deleteSuccessMsg}
        errorList={selectedMessageId === message.messageApprovalId && deleteErrorList}
      />
    }
    {/* <Link to='#' className='g_m_left_50' message-approval-id={message.messageApprovalId}
      onClick={onDocsUploadClick}>
      Upload
    </Link> */}
  </div>
)

export default PendingMessageApprovalWhatsAppListUI